module.exports = __webpack_public_path__ + "img/ur.8e1b819c.svg";